var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v23H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90A9C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M3.91 8.153c-3.885.276-3.875 5.905 0 6.18h9.2a4.44 4.44 0 0 0 3.019-1.161c2.724-2.38 1.267-7.143-2.324-7.6C12.52-2.18 1.292.763 3.95 8.153"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90A9C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M9.272 14.334v2.857",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90A9C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M9.272 21a1.905 1.905 0 1 0 0-3.81 1.905 1.905 0 0 0 0 3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90A9C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M14.987 19.095h-3.81M7.368 19.095h-3.81",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCloud);
export default __webpack_public_path__ + "static/media/miniCloud.9110f82da419e9709f060103ba929967.svg";
export { ForwardRef as ReactComponent };